"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubscriptionsByFormGuid = void 0;

var getSubscriptionsByFormGuid = function getSubscriptionsByFormGuid(state) {
  return state.subscriptions.subscriptionsByFormGuid;
};

exports.getSubscriptionsByFormGuid = getSubscriptionsByFormGuid;